// Find/Edit CUSTOM for custom form details

function injectCSSAndText() {
    const shopifyEmbed = document.querySelector('shopify-forms-embed#app-embed');
    if (shopifyEmbed && shopifyEmbed.shadowRoot) {
        
        /* CSS STYLES */
        const style = document.createElement('style');
        style.textContent = `
            a {
                font-family: var(--lbd-font-family-regular) !important;
                font-size: var(--lbd-font-size) !important;
                color: var(--lbd-text-color) !important;
                letter-spacing: var(--lbd-letter-spacing) !important;
                line-height: 1.5 !important;
                margin: 0 !important;
                text-decoration: underline !important;
            }

            /* CONTAINER LAYOUT */
            [class*="gridItemContent"] {
                padding: 0 var(--lbd-large-margin) !important;
            }

            [class*="inline"] [class*="formContainer"] {
                max-width: 100% !important;
                width: 100% !important;
            }

            @media (min-width: 992px) {
                [class*="inline"] [class*="formContainer"] {
                    max-width: 66.666667% !important;
                }
            }

            [class*="gridItem"]:nth-child(2) {
                width: calc(100% - var(--lbd-large-margin) * 2) !important;
            }

            /* HEADINGS AND DESCRIPTION */
            section h2 {
                font-family: var(--lbd-font-family-medium) !important;
                font-size: var(--lbd-font-size) !important;
                color: var(--lbd-accent-color-100) !important;
                text-transform: uppercase !important;
                letter-spacing: var(--lbd-letter-spacing) !important;
                margin: 0 !important;
                line-height: 1.5 !important;
                font-weight: normal !important;
            }
            
            .shopify-form-description {
                font-family: var(--lbd-font-family-regular) !important;
                font-size: var(--lbd-font-size) !important;
                color: var(--lbd-text-color) !important;
                letter-spacing: var(--lbd-letter-spacing) !important;
                line-height: 1.5 !important;
                margin: var(--lbd-minor-margin) 0 !important;
            }
            
            .shopify-form-description p {
                margin: var(--lbd-minor-margin) 0 !important;
            }
            
            .shopify-form-description p:first-child {
                margin-top: 0 !important;
            }
            
            .shopify-form-description p:last-child {
                margin-bottom: 0 !important;
            }
            
            .shopify-form-description a {
                text-decoration: underline;
            }

            /* FORM INPUTS */
            .field__input {
                padding: var(--lbd-minor-margin) !important;
                background-color: var(--lbd-background-color) !important;
                font-family: var(--lbd-font-family-regular) !important;
                font-size: var(--lbd-font-size) !important;
                letter-spacing: var(--lbd-letter-spacing) !important;
                border: var(--lbd-line-width) solid var(--lbd-line-color) !important;
                border-radius: var(--lbd-rounded-corner-radius) !important;
                box-shadow: none !important;
                width: 100% !important;
                box-sizing: border-box !important;
            }

            .field__input:focus {
                border: var(--lbd-line-width) solid var(--lbd-line-color) !important;
                outline: none !important;
            }

            .field__label {
                font-family: var(--lbd-font-family-regular) !important;
                font-size: var(--lbd-font-size) !important;
                letter-spacing: var(--lbd-letter-spacing) !important;
                color: rgba(var(--color-foreground),.75) !important;
                opacity: 0.5 !important;
                transition: opacity 0.3s ease !important;
                position: absolute !important;
                left: var(--lbd-minor-margin) !important;
                pointer-events: none !important;
                transform: none !important;
            }

            .field__input:focus ~ .field__label,
            .field__input:not(:placeholder-shown) ~ .field__label {
                opacity: 0 !important;
            }

            .field {
                position: relative !important;
                margin-bottom: calc(var(--lbd-minor-gap) + 0.25rem) !important;
            }

            [class*="formFieldContainer"]:has(textarea)::before,
            [class*="formFieldContainer"]:has(textarea)::after {
                background: none !important;
                display: none !important;
            }

            form[data-testid="form"],
            [class*="formFieldset"] {
                gap: 0 !important;
            }

            /* SELECT DROPDOWNS */
            [class*="selectContainer"] p[class*="label"] {
                font-family: var(--lbd-font-family-medium) !important;
                font-size: var(--lbd-font-size) !important;
                color: var(--lbd-text-color) !important;
                margin-bottom: calc(var(--lbd-minor-margin) / 2) !important;
            }

            [class*="selectContainer"] p {
                font-family: var(--lbd-font-family-regular) !important;
                font-size: var(--lbd-font-size) !important;
                color: var(--lbd-text-color) !important;
                margin-bottom: calc(var(--lbd-minor-margin) / 2) !important;
            }

            [class*="flagIcon"] {
                display: none !important;
            }

            .phone-country-selector > div {
                position: relative !important;
            }

            .lbd-select-wrapper {
                position: relative;
                margin-bottom: calc(var(--lbd-minor-gap) + 0.25rem) !important;
            }

            .lbd-select-wrapper select {
                display: none !important;
            }

            .select-display {
                font-family: var(--lbd-font-family-medium);
                font-size: var(--lbd-font-size);
                color: var(--lbd-accent-color-100);
                padding: var(--lbd-minor-margin);
                background-color: var(--lbd-background-color);
                border: var(--lbd-line-width) solid var(--lbd-accent-color-100);
                border-radius: var(--lbd-rounded-corner-radius);
                cursor: pointer;
                position: relative;
            }

            .phone-country-selector > div > div > .select-display {
                max-height: 17px !important;
            }

            .select-display:focus {
                outline: none !important;
                box-shadow: none !important;
            }

            .select-options {
                position: absolute;
                top: 100%;
                left: 0;
                right: 0;
                background-color: var(--lbd-background-color);
                border: var(--lbd-line-width) solid var(--lbd-accent-color-100);
                border-top: none;
                border-radius: 0 0 var(--lbd-rounded-corner-radius) var(--lbd-rounded-corner-radius);
                max-height: 200px;
                overflow-y: auto;
                z-index: 100;
            }

            .select-options.hidden {
                display: none;
            }

            .select-option {
                font-family: var(--lbd-font-family-regular);
                color: var(--lbd-text-color);
                padding: var(--lbd-minor-margin);
                cursor: pointer;
            }

            .select-option:hover {
                background-color: var(--lbd-accent-color-60);
            }

            .select-option.selected {
                background-color: var(--lbd-accent-color-40);
            }

            .lbd-select-wrapper::after {
                content: '';
                position: absolute;
                top: 50%;
                right: 20px;
                transform: translateY(-50%);
                pointer-events: none;
                width: 10px;
                height: 6px;
                background-image: url('data:image/svg+xml;utf8,<svg aria-hidden="true" focusable="false" viewBox="0 0 10 6" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"/></svg>');
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center;
                transition: transform 0.3s ease;
            }

            .lbd-select-wrapper.active::after {
                transform: translateY(-50%) rotate(180deg);
            }

            /* FILE UPLOAD */
            button[id*="files-label"],
            [class*="formFileInputField"] {
                font-family: var(--lbd-font-family-medium) !important;
                font-size: var(--lbd-font-size) !important;
                color: var(--lbd-accent-color-100) !important;
                padding: var(--lbd-minor-margin) !important;
                background-color: var(--lbd-background-color) !important;
                border: var(--lbd-line-width) solid var(--lbd-line-color) !important;
                border-radius: var(--lbd-rounded-corner-radius) !important;
                cursor: pointer !important;
                display: inline-block !important;
                margin-bottom: calc(var(--lbd-minor-gap) + 0.25rem) !important;
            }

            p[class*="formFileInputButton"] {
                background-color: var(--lbd-dark-background-color) !important;
                color: var(--lbd-accent-color-100) !important;
                font-family: var(--lbd-font-family-regular) !important;
                font-size: var(--lbd-font-size) !important;
                letter-spacing: var(--lbd-letter-spacing) !important;
                margin: 0 !important;
            }

            p[class*="formFileInputButton"]:hover {
                background-color: var(--lbd-accent-color-40) !important;
            }

            [class*="formFileInputFileName"] span {
                color: var(--lbd-text-color) !important;
                font-family: var(--lbd-font-family-regular) !important;
                font-size: var(--lbd-font-size) !important;
                letter-spacing: var(--lbd-letter-spacing) !important;
                margin: 0 !important;
            }

            button[id*="files-clear"] svg,
            [class*="formFileInputCancelButton"] svg {
                transform: scale(0.8) !important;
                fill: var(--lbd-text-color) !important;
            }

            /* SUBMIT BUTTON */
            button[type="submit"][data-testid="btn-form-submit"],
            [class*="formSubmitButton"] {
                border: var(--lbd-line-width) solid var(--lbd-accent-color-100) !important;
                background-color: var(--lbd-background-color) !important;
                border-radius: var(--lbd-rounded-corner-radius) !important;
                padding: var(--lbd-minor-margin) !important;
                min-width: 20rem !important;
                max-width: fit-content !important;
                color: var(--lbd-accent-color-100) !important;
                font-family: var(--lbd-font-family-regular) !important;
                font-size: var(--lbd-font-size) !important;
                letter-spacing: var(--lbd-letter-spacing) !important;
                text-decoration: none !important;
                cursor: pointer !important;
                transition: background-color 0.3s ease, font-family 0.3s ease !important;
                box-shadow: none !important;
            }

            button[type="submit"][data-testid="btn-form-submit"]:hover,
            [class*="formSubmitButton"]:hover {
                background-color: var(--lbd-accent-color-40) !important;
                font-family: var(--lbd-font-family-medium) !important;
                text-decoration: none !important;
            }

            button[type="submit"][data-testid="btn-form-submit"]:disabled,
            [class*="formSubmitButton"]:disabled {
                opacity: 0.5 !important;
                cursor: not-allowed !important;
            }

            [class*="spinner"] svg,
            [data-testid="spinner-icon"] svg {
                fill: var(--lbd-minor-text-color) !important;
            }

            [class*="spinner"] svg path,
            [data-testid="spinner-icon"] svg path {
                fill: var(--lbd-minor-text-color) !important;
            }

            /* FORM ERROR MESSAGES */
            [class*="formError"],
            output[role="alert"] {
                font-family: var(--lbd-font-family-regular) !important;
                font-size: var(--lbd-font-size) !important;
                letter-spacing: var(--lbd-letter-spacing) !important;
                padding-bottom: calc(var(--lbd-minor-gap) + 0.25rem) !important;
            }

            [class*="textBody"] p {
                font-family: var(--lbd-font-family-regular) !important;
                font-size: var(--lbd-font-size) !important;
                letter-spacing: var(--lbd-letter-spacing) !important;
                padding-top: calc(var(--lbd-minor-gap) + 0.25rem) !important;
            }
        `;
        
        shopifyEmbed.shadowRoot.appendChild(style);
        
        /* FORM DESCRIPTION - CUSTOM */

        /* BESPOKE FORM */
        const outsideFormRoot = document.querySelector('[data-forms-id="forms-root-724409"]');
        const h2 = shopifyEmbed.shadowRoot.querySelector('section h2');

        if (outsideFormRoot && h2 && !h2.nextElementSibling?.classList.contains('shopify-form-description')) {
            const description = document.createElement('div');
            description.className = 'shopify-form-description';
            description.innerHTML = `
                <p>Begin designing your bespoke piece with a complimentary virtual consultation. If any choices feel overwhelming, rest assured, we will thoughtfully explore each option together.</p>
                <p>Contact us at <a href="mailto:support@lovebydeccla.com">support@lovebydeccla.com</a> or complete the form below to get started.</p>
            `;
            h2.parentNode.insertBefore(description, h2.nextSibling);
        }

        /* LABEL FORMATTING */
        const selectLabels = shopifyEmbed.shadowRoot.querySelectorAll('[class*="selectContainer"] p[class*="label"]');
        selectLabels.forEach(label => {
            const text = label.textContent;
            if (text.includes('(Optional)')) {
                const parts = text.split('(Optional)');
                label.innerHTML = `${parts[0].trim()} <span style="color: var(--lbd-minor-text-color) !important; font-family: var(--lbd-font-family-regular) !important;">(Optional)</span>`;
            }
        });

        const fileLabels = shopifyEmbed.shadowRoot.querySelectorAll('p[class*="textBody"]');
        fileLabels.forEach(label => {
            const text = label.textContent;
            if (text.includes('(Optional)')) {
                const parts = text.split('(Optional)');
                label.innerHTML = `${parts[0].trim()} <span style="color: var(--lbd-minor-text-color) !important; font-family: var(--lbd-font-family-regular) !important;">(Optional)</span>`;
                label.style.fontFamily = 'var(--lbd-font-family-medium)';
                label.style.fontSize = 'var(--lbd-font-size)';
                label.style.color = 'var(--lbd-text-color)';
            }
        });

        /* INPUT FIELD CLASSES */
        const inputContainers = shopifyEmbed.shadowRoot.querySelectorAll('[class*="formFieldContainer"]');
        inputContainers.forEach(container => {
            container.classList.add('field');
            
            const input = container.querySelector('input, textarea');
            if (input) {
                input.classList.add('field__input');
                input.setAttribute('placeholder', ' ');
            }
            
            const label = container.querySelector('label');
            if (label) {
                label.classList.add('field__label');
            }
        });

        /* WATCH FOR CLASS CHANGES */
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(mutation => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const target = mutation.target;
                    
                    if (target.matches('input, textarea') && !target.classList.contains('field__input')) {
                        target.classList.add('field__input');
                    }
                    
                    if (target.matches('label') && !target.classList.contains('field__label')) {
                        target.classList.add('field__label');
                    }
                    
                    if (target.matches('[class*="formFieldContainer"]') && !target.classList.contains('field')) {
                        target.classList.add('field');
                    }
                }
            });
        });

        inputContainers.forEach(container => {
            observer.observe(container, {
                attributes: true,
                attributeFilter: ['class'],
                subtree: true
            });
        });

        /* STYLE PHONE ERROR MESSAGES */
        const errorObserver = new MutationObserver(function(mutations) {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1 && node.matches('output[role="alert"]')) {
                        if (node.textContent.includes('Phone number')) {
                            node.style.marginTop = '-0.75rem';
                        }
                    }
                });
            });
        });

        errorObserver.observe(shopifyEmbed.shadowRoot, {
            childList: true,
            subtree: true
        });

        /* COUNTRY SELECTOR DROPDOWN */
        const countryButton = shopifyEmbed.shadowRoot.querySelector('button[aria-controls="country-selector-dropdown"]');
        if (countryButton) {
            const countryContainer = countryButton.closest('.phone-country-selector > div');
            
            if (countryContainer && !countryContainer.querySelector('.lbd-select-wrapper')) {
                const flagImg = countryButton.querySelector('[class*="flagIcon"]');
                const initialCountry = flagImg ? flagImg.alt.substring(0, 2).toUpperCase() : 'AU';
                const countries = ['AU', 'US', 'UK', 'CA', 'NZ', 'SG', 'HK'];
                
                countryButton.style.display = 'none';
                
                const wrapper = document.createElement('div');
                wrapper.className = 'lbd-select-wrapper';
                wrapper.style.maxWidth = '80px';
                
                const display = document.createElement('div');
                display.className = 'select-display';
                display.textContent = initialCountry;
                
                const optionsContainer = document.createElement('div');
                optionsContainer.className = 'select-options hidden';
                
                countries.forEach((country) => {
                    const optDiv = document.createElement('div');
                    optDiv.className = 'select-option' + (country === initialCountry ? ' selected' : '');
                    optDiv.textContent = country;
                    
                    optDiv.addEventListener('click', function() {
                        display.textContent = country;
                        
                        optionsContainer.querySelectorAll('.select-option').forEach(o => {
                            o.classList.remove('selected');
                        });
                        this.classList.add('selected');
                        optionsContainer.classList.add('hidden');
                        wrapper.classList.remove('active');
                        
                        const shopifyToggleText = countryButton.querySelector('[class*="selectToggleText"]');
                        if (shopifyToggleText) {
                            shopifyToggleText.textContent = country;
                        }
                    });
                    
                    optionsContainer.appendChild(optDiv);
                });
                
                display.addEventListener('click', function(e) {
                    e.stopPropagation();
                    const isHidden = optionsContainer.classList.contains('hidden');
                    
                    shopifyEmbed.shadowRoot.querySelectorAll('.select-options').forEach(opt => {
                        opt.classList.add('hidden');
                    });
                    shopifyEmbed.shadowRoot.querySelectorAll('.lbd-select-wrapper').forEach(w => {
                        w.classList.remove('active');
                    });
                    
                    if (isHidden) {
                        optionsContainer.classList.remove('hidden');
                        wrapper.classList.add('active');
                    }
                });
                
                wrapper.appendChild(display);
                wrapper.appendChild(optionsContainer);
                countryContainer.insertBefore(wrapper, countryButton);
            }
        }

        /* CUSTOM DROPDOWNS - CUSTOM */
        const selectContainers = shopifyEmbed.shadowRoot.querySelectorAll('[class*="selectContainer"]');
        selectContainers.forEach(container => {
            const button = container.querySelector('button');
            const label = container.querySelector('p');
            
            if (!button || button.getAttribute('aria-controls') === 'country-selector-dropdown') {
                return;
            }

            const labelText = label?.textContent || '';
            let options = [];

            /* BESPOKE FORM - METAL TYPE & BUDGET */
            if (labelText.includes('Metal')) {
                options = ['Not Sure Yet', '18K Yellow Gold', '18K Rose Gold', '18K White Gold', 'Platinum'];
            } else if (labelText.includes('Budget')) {
                options = ['Not Sure Yet', 'Custom Amount', 'Up to $3,000', '$3,000 to $6,000', '$6,000 to $10,000', 'Over $10,000'];
            }

            if (options.length === 0) return;

            button.style.display = 'none';

            const wrapper = document.createElement('div');
            wrapper.className = 'lbd-select-wrapper';
            
            const display = document.createElement('div');
            display.className = 'select-display';
            display.textContent = options[0];
            
            const optionsContainer = document.createElement('div');
            optionsContainer.className = 'select-options hidden';
            
            options.forEach((optText, index) => {
                const optDiv = document.createElement('div');
                optDiv.className = 'select-option' + (index === 0 ? ' selected' : '');
                optDiv.textContent = optText;
                
                optDiv.addEventListener('click', function() {
                    display.textContent = optText;
                    
                    const shopifyToggleText = button.querySelector('[class*="selectToggleText"]');
                    if (shopifyToggleText) {
                        shopifyToggleText.textContent = optText;
                    }
                    
                    optionsContainer.querySelectorAll('.select-option').forEach(o => {
                        o.classList.remove('selected');
                    });
                    this.classList.add('selected');
                    optionsContainer.classList.add('hidden');
                    wrapper.classList.remove('active');
                });
                
                optionsContainer.appendChild(optDiv);
            });
            
            display.addEventListener('click', function(e) {
                e.stopPropagation();
                const isHidden = optionsContainer.classList.contains('hidden');
                
                shopifyEmbed.shadowRoot.querySelectorAll('.select-options').forEach(opt => {
                    opt.classList.add('hidden');
                });
                shopifyEmbed.shadowRoot.querySelectorAll('.lbd-select-wrapper').forEach(w => {
                    w.classList.remove('active');
                });
                
                if (isHidden) {
                    optionsContainer.classList.remove('hidden');
                    wrapper.classList.add('active');
                }
            });
            
            wrapper.appendChild(display);
            wrapper.appendChild(optionsContainer);
            button.parentNode.insertBefore(wrapper, button);
        });

        /* CLOSE DROPDOWNS ON OUTSIDE CLICK */
        shopifyEmbed.shadowRoot.addEventListener('click', function(e) {
            if (!e.target.closest('.lbd-select-wrapper')) {
                shopifyEmbed.shadowRoot.querySelectorAll('.select-options').forEach(opt => {
                    opt.classList.add('hidden');
                });
                shopifyEmbed.shadowRoot.querySelectorAll('.lbd-select-wrapper').forEach(w => {
                    w.classList.remove('active');
                });
            }
        });

        return true;
    }
    return false;
}

function tryInject(attempt = 1, maxAttempts = 10) {
    if (injectCSSAndText()) {
        return;
    }
    
    if (attempt < maxAttempts) {
        setTimeout(() => tryInject(attempt + 1, maxAttempts), 500);
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => tryInject());
} else {
    tryInject();
}